import { motion, useReducedMotion } from 'motion/react';
import { GOD_GLYPHS } from '../data/godGlyphs';

/**
 * The symbol of a strategy's god: a glyph from game-icons.net (CC BY 3.0, see data/godGlyphs.js),
 * filled in the strategy's colour. It settles into place the first time it scrolls into view.
 */
export function hasSigil(slug) {
  return Boolean(GOD_GLYPHS[slug]);
}

export default function StrategySigil({ slug, size = 56, color = '#00ffc8', delay = 0, once = true, style }) {
  const glyph = GOD_GLYPHS[slug];
  const reduce = useReducedMotion();
  if (!glyph) return null;
  return (
    <motion.svg
      viewBox="0 0 512 512"
      width={size}
      height={size}
      initial={reduce ? false : { opacity: 0, scale: 0.92 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once, amount: 0.4 }}
      transition={{ duration: 0.4, delay, ease: [0.23, 1, 0.32, 1] }}
      style={{ display: 'block', flex: '0 0 auto', ...style }}
      aria-hidden="true"
    >
      <path d={glyph.d} fill={color} />
    </motion.svg>
  );
}
